import { TradeGlyph } from "@volca/ui/components/ui/trade-glyph";
import { RECORD_KINDS } from "@volca/ui/trades";
import type { ReportObjectIcon } from "@/profitability/types";

/** An object's kind, as its trade glyph: a column header, a tab. */
export const ObjectIcon = ({
  icon,
  className,
}: {
  icon: ReportObjectIcon;
  className?: string;
}) => (
  <TradeGlyph
    name={RECORD_KINDS[icon]?.glyph ?? "part"}
    className={className}
  />
);
